import { useMemo } from 'react'
import { useQuery as useApolloQuery } from '@apollo/client'

export function useQuery(query, opts = {}, variables) {
  const path = useMemo(() => query.definitions[0].selectionSet.selections[0].name.value, [query])

  const { data, ...rest } = useApolloQuery(query, {
    ...opts,
    variables: {
      ...variables,
      ...opts.variables
    }
  })

  return {
    data: data?.[path],
    ...rest
  }
}
